import { daysUntilBirthday } from './map-congregacion-row';

/** Ventana en la que el cumpleanios se avisa en el chat. */
const DIAS_AVISO_CUMPLE = 30;

export function chatCumpleProximo(nacimiento?: string | null, hoy: Date = new Date()): boolean {
  const dias = daysUntilBirthday(nacimiento, hoy);
  return dias !== null && dias <= DIAS_AVISO_CUMPLE;
}

/** Texto para la cabecera del chat; null si no corresponde avisar. */
export function chatCumpleLabel(nacimiento?: string | null, hoy: Date = new Date()): string | null {
  const dias = daysUntilBirthday(nacimiento, hoy);
  if (dias === null || dias > DIAS_AVISO_CUMPLE) {
    return null;
  }
  if (dias === 0) {
    return 'Cumple a\u00f1os Hoy';
  }
  if (dias === 1) {
    return 'Cumple a\u00f1os Ma\u00f1ana';
  }
  return `Cumplea\u00f1os en ${dias} d\u00edas`;
}
